import { Select } from "@tfg/ui"
import { Dispatch, SetStateAction } from "react"
import { useTranslation } from "react-i18next"

import { removeUndefined } from "@tfg/types/schemas/utils"

import {
  type CertificateRequestDtoStatusEnumKey,
  certificateRequestDtoStatusEnum,
} from "~/gen/api/types/CertificateRequestDto"
import { FindCertificateRequestsForSupplierQueryParams } from "~/gen/api/types/FindCertificateRequestsForSupplier"

type Props = {
  params: FindCertificateRequestsForSupplierQueryParams
  setParams: Dispatch<
    SetStateAction<FindCertificateRequestsForSupplierQueryParams>
  >
}

export const CertificateRequestStatusFilter = ({
  params,
  setParams,
}: Props) => {
  const { t } = useTranslation(["traceability"])

  const STATUS_OPTIONS = [
    {
      label: t("certificateRequestStatus.OPENED"),
      value: certificateRequestDtoStatusEnum.OPENED,
    },
    {
      label: t("certificateRequestStatus.SUBMITTED"),
      value: certificateRequestDtoStatusEnum.SUBMITTED,
    },
    {
      label: t("certificateRequestStatus.REJECTED"),
      value: certificateRequestDtoStatusEnum.REJECTED,
    },
    {
      label: t("certificateRequestStatus.ACCEPTED"),
      value: certificateRequestDtoStatusEnum.ACCEPTED,
    },
  ]
  return (
    <Select
      placeholder={t("filters.status.placeholder")}
      value={params.status ?? null}
      onChange={(val) => {
        if (val && isCertificateRequestStatus(val)) {
          setParams((prev) => ({ ...prev, status: val }))
        } else {
          setParams((prev) => removeUndefined({ ...prev, status: undefined }))
        }
      }}
      data={STATUS_OPTIONS}
      w={180}
      clearable
    />
  )
}

const isCertificateRequestStatus = (
  val: string
): val is CertificateRequestDtoStatusEnumKey => {
  return Object.keys(certificateRequestDtoStatusEnum).includes(val)
}
